import { render, staticRenderFns } from "./agen-naik-kelas-progress.vue?vue&type=template&id=5f0aa871&scoped=true"
import script from "./agen-naik-kelas-progress.vue?vue&type=script&lang=js"
export * from "./agen-naik-kelas-progress.vue?vue&type=script&lang=js"
import style0 from "./agen-naik-kelas-progress.vue?vue&type=style&index=0&id=5f0aa871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0aa871",
  null
  
)

export default component.exports